import React, { useState, useEffect } from 'react';

interface UptimeDisplayProps {
  startTime: string;
}

const UptimeDisplay: React.FC<UptimeDisplayProps> = ({ startTime }) => {
  const [uptime, setUptime] = useState<string>('');

  useEffect(() => {
    const calculateUptime = () => {
      const start = new Date(startTime);
      const now = new Date();
      const diff = now.getTime() - start.getTime();

      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));

      let uptimeStr = '';
      if (days > 0) uptimeStr += `${days}d `;
      if (hours > 0) uptimeStr += `${hours}h `;
      uptimeStr += `${minutes}m`;

      setUptime(uptimeStr);
    };

    // Calculate initial uptime
    calculateUptime();

    // Update every minute
    const interval = setInterval(calculateUptime, 60000);

    return () => clearInterval(interval);
  }, [startTime]);

  return (
    <div className="text-sm text-gray-400">
      Server uptime: {uptime}
    </div>
  );
};

export default UptimeDisplay; 